var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../../components/UnlinkedApplicationForm";
import { AutoEntity, saveAutoEntity, } from "../../../../../features/unlinked-application/unlinkedApplicationSlice";
import { Button, TextField } from "@savvyinsure/react-ui";
import AppBody from "../../../../../components/AppBody";
import Header from "../../../../../components/Header";
import { PHASE } from "../../../../../routeConfig";
import { completedPage } from "../../../../../lib/Avo";
import { toVehicleInfoValue } from "../../../../../services/savvy/utils";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useLazyVinLookupQuery } from "../../../../../services/savvy";
import useMemoryHistory from "../../../../../hooks/useMemoryHistory";
import { useParams } from "react-router-dom";
export default function UnlinkedApplicationAutoVehicleEditVin() {
    var vehicleId = useParams().vehicleId;
    var _a = useForm({
        defaultValues: { vin: null },
    }), register = _a.register, handleSubmit = _a.handleSubmit;
    var _b = useLazyVinLookupQuery(), lookupVin = _b[0], result = _b[1];
    var dispatch = useAppDispatch();
    var push = useMemoryHistory().push;
    var _c = React.useState(""), error = _c[0], setError = _c[1];
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var onSubmit = handleSubmit(function (formData) {
        if (!formData.vin)
            return;
        lookupVin(formData.vin)
            .unwrap()
            .then(function (data) {
            var parsedData = Object.entries(data).reduce(function (parsed, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return value
                    ? __assign(__assign({}, parsed), (_b = {}, _b[key] = toVehicleInfoValue(value), _b)) : parsed;
            }, {});
            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Continue", optionSelected: "Continue" }));
            dispatch(saveAutoEntity({
                entity: AutoEntity.Vehicle,
                data: __assign(__assign({ id: vehicleId }, parsedData), { trim: __assign(__assign({}, parsedData.trim), (formData.vin && { vin: toVehicleInfoValue(formData.vin) })) }),
            }));
            push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_STATUS.replace(":vehicleId", vehicleId));
        })
            .catch(function () {
            // we received incomplete vin data
            setError("Invalid VIN number");
        });
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", action: "#", onSubmit: onSubmit },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, { className: "pt-6" },
                React.createElement(UnlinkedApplicationForm.Header, { className: "mb-4" }, "Let's get started with your vehicle information. Subtext"),
                React.createElement("div", { className: "mb-3 w-full" },
                    React.createElement("button", { onClick: function (event) {
                            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: event === null || event === void 0 ? void 0 : event.currentTarget.textContent, optionSelected: event === null || event === void 0 ? void 0 : event.currentTarget.textContent }));
                            push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR.replace(":vehicleId", vehicleId));
                        }, className: "text-sm font-semibold leading-none text-savvy", type: "button" }, "Switch back to regular vehicle lookup.")),
                React.createElement(TextField, __assign({ label: "VIN" }, register("vin", { required: true }), { errorMessage: error, "aria-invalid": Boolean(error) }))),
            React.createElement("div", { className: "bg-white p-4" },
                React.createElement(Button, { disabled: result.isFetching || result.isLoading }, "Continue")))));
}
